import { render, staticRenderFns } from "./ConfirmRegisterInvite.vue?vue&type=template&id=44d8c665&"
import script from "./ConfirmRegisterInvite.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegisterInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports